var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-icon',{attrs:{"icon":"edit"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  Edit\n")])}
var staticRenderFns = []

export { render, staticRenderFns }